import { RefObject, useEffect } from 'react';

export const useClickOutside = (
  refs: RefObject<HTMLElement | null>[],
  handleOnClickOutside: (event: MouseEvent | TouchEvent) => void,
) => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Node;

      if (refs && refs.length > 0) {
        const isInsideAnyRef = refs.some((ref) =>
          ref.current?.contains(target),
        );

        if (isInsideAnyRef) return;
      }

      handleOnClickOutside(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [refs, handleOnClickOutside]);
};
